@if(!loading && showContent){
<div class="page-wrapper never-printed-wrapper">
	@if (!isLoadInProgress) {
	<div class="top-control-wrapper">
		<div class="left-side">
			<input
				class="form-control search-input"
				[(ngModel)]="searchString"
				(ngModelChange)="sortByPartner()"
				placeholder="Search..."
			/>
			<button type="submit" class="btn btn-info simpleRfIdColor load-items-button" (click)="loadNeverPrinted()">
				Load
			</button>
		</div>
		<div class="right-side">
			<div class="check-input-container">
				<input id="excludeZero" type="checkbox" [(ngModel)]="excludeZero" (ngModelChange)="sortByPartner()" />
				<label for="excludeZero">Exclude items with a quantity of 0</label>
			</div>
			<button
				type="submit"
				class="btn btn-info simpleRfIdColor print-selected-button"
				(click)="openPrintModal()"
				[disabled]="!isPrintingEnable"
				[ngbTooltip]="isPrintingEnableTitle"
				[openDelay]="300"
				[closeDelay]="300"
			>
				Print
				<span *ngIf="countItemsToPrint > 0">({{ countItemsToPrint }})</span>
			</button>
		</div>
	</div>

	<div class="div-table-wrapper">
		<div class="header-row">
			<div class="header-cell col-img">Image</div>
			<div class="header-cell col-title">Product Name</div>
			<div class="header-cell col-key">{{ productKey }}</div>
			<div class="header-cell col-platform">
				<span (click)="sortByPartner(true)" class="cursor-pointer">
					{{ data.platform }}
					@switch(isSortedByPatnerAscending){ @case ('default') {
					<img src="./assets/images/sort.png" />
					} @case ('asc') {
					<img src="./assets/images/sort-up.png" />
					} @case ('desc') {
					<img src="./assets/images/sort-down.png" />
					} }
				</span>
			</div>
			<div class="header-cell col-check">
				<input
					type="checkbox"
					name="syncAll"
					[(ngModel)]="syncAll"
					[checked]="syncAll"
					(ngModelChange)="adjustSelection()"
					[disabled]="selectAllDisabled"
				/>
			</div>
			<div class="header-cell scroll-gap"></div>
		</div>
		<div class="header-row second-header">
			<div class="header-cell col-img"></div>
			<div class="header-cell col-title"></div>
			<div class="header-cell col-key">
				{{ inventoryStorage.neverPrintedCount }}
			</div>
			<div class="header-cell col-platform">
				{{ inventoryStorage.allCurrentCount }}
			</div>
			<div class="header-cell col-check"></div>
			<div class="header-cell scroll-gap"></div>
		</div>

		@if(filteredItems.length > 0){
		<cdk-virtual-scroll-viewport class="scroll-viewport" [itemSize]="50" [bufferSize]="50">
			<div *cdkVirtualFor="let product of filteredItems; let i = index; templateCacheSize: 0" class="table-row">
				<div class="table-cell col-img">
					<div class="table-img-box">
						<app-image-handler [product]="product"></app-image-handler>
					</div>
				</div>
				<div class="table-cell col-title">
					{{ product.Title }}
				</div>
				<div class="table-cell col-key">{{ product.Sku }}</div>
				<div title="Current" class="table-cell col-platform" [class.text-yellow]="product.isAdjusted">
					{{ product.CurrentCount }}
				</div>
				<div class="table-cell col-check">
					<input
						type="checkbox"
						name="sync{{ i }}"
						[checked]="product.check"
						(change)="changeSelection(product)"
						(click)="toggleSelected(i, $event)"
						oninput="this.value = this.value.replace(/\D/g, '')"
					/>
				</div>
			</div>
		</cdk-virtual-scroll-viewport>

		}
	</div>
	} @else {
	<div class="items-loader">
		<h3>Loading Never Printed</h3>
		<app-progress-bar
			[data]="progressBarLoadNeverPrinted"
			(onProgress)="loadInProgress()"
			(onFinish)="finishLoad()"
		></app-progress-bar>
	</div>
	}
</div>
} @else{
<div class="page-loader">
	<div class="spinner"></div>
</div>
}
